import { SIDE_NAV_LIGHT, NAV_TYPE_SIDE, DIR_LTR } from 'constants/ThemeConstant';
import { env } from './EnvironmentConfig'

export const APP_NAME = 'TikTok Platform';
export const API_BASE_URL = env.PLATFORM_API_URL;
export const APP_PREFIX_PATH = '/app';
export const AUTH_PREFIX_PATH = '/auth';
export const REDIRECT_URL_KEY = 'redirect'

// Define different entry points
export const ADMIN_ENTRY = `${APP_PREFIX_PATH}/admin/users`;
export const DEFAULT_ENTRY = `${APP_PREFIX_PATH}/dashboards/default`;


export const getAuthenticatedEntry = (user) => {
    if (user && user.role === 'admin' && !user.tiktokId) {
        return ADMIN_ENTRY;
    }
    return DEFAULT_ENTRY;
};

export const AUTHENTICATED_ENTRY = DEFAULT_ENTRY;
export const UNAUTHENTICATED_ENTRY = '/login'

export const THEME_CONFIG = {
	navCollapsed: false,
	sideNavTheme: SIDE_NAV_LIGHT,
	locale: 'en',
	navType: NAV_TYPE_SIDE,
	topNavColor: '#3e82f7',
	headerNavColor: '',
	mobileNav: false,
	currentTheme: 'light',
	direction: DIR_LTR,
	blankLayout: false
};
